import { render } from "./WorkingSiteTags.vue?vue&type=template&id=71e8f005&scoped=true&ts=true&lang=pug"
import script from "./WorkingSiteTags.vue?vue&type=script&lang=ts"
export * from "./WorkingSiteTags.vue?vue&type=script&lang=ts"

import "./WorkingSiteTags.vue?vue&type=style&index=0&id=71e8f005&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e8f005"]])

export default __exports__